module.exports = __webpack_public_path__ + "img/en.602993cf.png";